import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import object1 from "../../Assets/img/invite_frnds.svg";
import copt_icon from "../../Assets/img/copy.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

class InviteFriends extends Component {
  state = {
    value: "https://puzzled.in/",
    copied: false,
  };

  render() {
    return (
      <div className="InviteFriends innerBody">
        <Header />
        <div className="container">
          <div className="row">
            <h3 className="title m-auto pt-5 pb-4">
              {" "}
              INVITE YOUR FRIENDS TO PLAY PUZZLED
            </h3>
          </div>
        </div>

        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-12 pt-3 pb-3">
              <img src={object1} className="" alt="" />
            </div>

            <div className="col-lg-6 col-md-12 col-12 share pt-3 pb-3">
              <p> Share Puzzled with your friends on Social Media </p>
              <ul className="list-unstyled list-inline list-social mb-6 mb-md-0">
                <li className="list-inline-item list-social-item">
                  <FacebookShareButton url={this.state.value}>
                    <FacebookIcon size={40} round />
                  </FacebookShareButton>
                </li>
                <li className="list-inline-item list-social-item ">
                  <TwitterShareButton url={this.state.value}>
                    <TwitterIcon size={40} round />
                  </TwitterShareButton>
                </li>
                <li className="list-inline-item list-social-item">
                <WhatsappShareButton url={this.state.value}>
                    <WhatsappIcon size={40} round />
                  </WhatsappShareButton>
                </li>
              </ul>
              <br /> <br />
              <div className="copytoclip text-xs-center">
                <input
                  value={this.state.value}
                  onChange={({ target: { value } }) =>
                    this.setState({ value, copied: false })
                  }
                />

                <CopyToClipboard
                  text={this.state.value}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <span></span>
                </CopyToClipboard>

                <CopyToClipboard
                  text={this.state.value}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <button className="btn btn-yellow">
                    {" "}
                    <img src={copt_icon} className="" alt="" />{" "}
                  </button>
                </CopyToClipboard>

                {this.state.copied ? (
                  <span className="pt3" style={{ color: "#5bd053" }}>
                    Copied.
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default InviteFriends;
